import { UserSessionsForDebugApi } from "../../generated"
import { useQuery } from 'react-query'
import { apiConfig } from "../apiConfig"
import { DebugLoginOption } from "./DebugLoginOption"
import { onError } from "../../office/stores/user/UserStore"

const api = new UserSessionsForDebugApi(apiConfig)

async function load() {
  return await api.listOffice()
}

export function useOfficeList() {
  const { data } = useQuery('useOfficeList', load, { onError })
  const options: DebugLoginOption[] | undefined = data?.map(office => {
    const d = `${office.office?.name} ${office.user?.name} (${office.user.account})`
    const id = office.user.id?.toString()
    return { value: id ? id : '', label: d }
  })
  return options ? options : []
}
